import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { toast } from 'sonner';
import { useAuthStore } from '../store/useAuthStore';
import { apiBaseURL } from '../config/apiConfig';

export const apiClient = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => config,
  (error: AxiosError) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    if (error.message === 'Network Error') {
      toast.error('Network connection lost. Please check your internet.');
    } 
    else if (status === 500) {
      toast.error('A server error occurred. Our team has been notified.');
    } 
    else if (status === 401) {
      // 1. If the 401 came from checking the session, JUST clear auth. Do NOT redirect.
      if (url.includes('/api/user')) {
        useAuthStore.getState().clearAuth();
        // Kill the stale cookie manually so it stops triggering the network call
        document.cookie = "XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      } 
      // 2. If the 401 came from somewhere else, and we ARE NOT already on the login page, then redirect.
      else if (!url.includes('/login') && window.location.pathname !== '/login') {
        // toast.error('Your session has expired. Please log in again.');
        useAuthStore.getState().clearAuth();
        // window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);